import { PROJECT_NAME } from 'src/constants';

export const LabelPro = () => {
  return (
    <label className="nj-label-pro" data-e2e="label-tier-pro">
      {`${PROJECT_NAME} Pro`}
    </label>
  );
};
